import React, { useState, useEffect } from "react";
import {
  Input,
  Row,
  Form,
  Col,
  InputNumber,
  notification,
  DatePicker,
  Button,
  Select,
  Checkbox,
  Tooltip,
} from "antd";
import moment from "moment";
import { PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import CurrencyInput from "react-currency-input";
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 11,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

const TenantAccountUpdateForm = (props) => {
  const { Option } = Select;
  const [activeTypeId, setActiveTypeId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    props.data.dueDate =
      props.data.dueDate !== null ? moment(props.data.dueDate) : null;
    setLoading(false);

    if (props.data) {
      props.data.typeValue =
        props.data.typeValue == null
          ? undefined
          : props.data.typeValue.toString();
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onFinishUpdate = (values) => {
    RequestHandler.put(
      `/TenantAccount`,
      {
        Id: values.id,
        Name: values.name,
        IsCalculated: values.isCalculated,
        Type: parseInt(values.typeValue),
        ErpCode: values.erpCode,
        ErpAccountingCode: values.erpAccountingCode,
        ErpBankCode: values.erpBankCode,
        DueDate: values.dueDate,
        InterestRate: values.interestRate,
        creditLimit: values.creditLimit,
      },
      false,
      { rawResponse: true }
    )
      .then((res) => {
        if (res.status == 200) {
          openNotificationWithIconUpdate("success");
          setTimeout(
            function () {
              props.sendDataForUpdate("success");
              setLoading(false);
            }.bind(this),
            2000
          );
        } else {
          setLoading(false);
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const openNotificationWithIconUpdate = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Güncelleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const onFinishFailedUpdate = () => setLoading(false);

  return (
    <div>
      <Form
        {...layout}
        name="basic"
        form={form}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinishUpdate}
        onFinishFailed={onFinishFailedUpdate}
      >
        <Row>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>

          <Col span={24}>
            <Form.Item
              style={{ marginTop: "4%" }}
              name="name"
              label="Banka Hesap Adı"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name="isCalculated"
              label="Hesaplamaya Dahil Et"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Banka Hesap Tipi" name="typeValue">
              <Select
                style={{ width: "100%" }}
                placeholder="Tip seçiniz"
                onChange={(value) => setActiveTypeId(value)}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLocaleLowerCase("tr-TR")
                    .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                }
              >
                <Option key="0">Vadesiz</Option>
                <Option key="1">Kredi</Option>
                <Option key="2">Vadeli</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label="Bayi Kod" name="erpCode">
              <Input />
            </Form.Item>
          </Col>

          {(props.data.isManualAccount === true &&
            props.data.type === "Vadeli" &&
            activeTypeId === 0) ||
          (props.data.isManualAccount === true &&
            activeTypeId === "2" &&
            activeTypeId !== 0) ? (
            <>
              <Col span={24}>
                <Form.Item label="Vade Bitiş Tarihi" name="dueDate">
                  <DatePicker format="DD.MM.YYYY" style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Vade Faiz Oranı" name="interestRate">
                  <InputNumber
                    style={{ width: "100%" }}
                    min={0}
                    max={100}
                    decimalSeparator=","
                    precision={2}
                  />
                </Form.Item>
              </Col>
            </>
          ) : null}

          <Col span={24}>
            <Form.Item label="Erp Muhasebe Kodu" name="erpAccountingCode">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Erp Banka Kodu" name="erpBankCode">
              <Input />
            </Form.Item>
          </Col>

          <Col span={24} hidden={!props.data.isHasManualEnterCreditLimit}>
            <Form.Item
              label={
                <span>
                  Ana Kredi Limiti{" "}
                  <Tooltip title="Ana Kredi Limiti bankadan dönmemektedir. Bu sebeple Ana Kredi Limiti değerini manuel olarak girebilirsiniz. Ancak bankanızda değişmesi halinde burada da güncellemeniz gerekmektedir. Aksi halde yanlış hesaplamalara sebebiyet verebilir.">
                    <QuestionCircleOutlined
                      className="gx-text-blue"
                      style={{
                        marginRight: 10,
                        marginTop: 6,
                        fontSize: "150%",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="creditLimit"
            >
              <CurrencyInput
                className="ant-input"
                style={{ width: "100%" }}
                decimalSeparator=","
                thousandSeparator="."
                onChange={(value, name) => {
                  form.setFieldsValue({
                    creditLimit: name,
                  });
                }}
              />
            </Form.Item>
          </Col>

          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}></Col>
          <Col span={6}>
            <Form.Item {...tailLayout}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default TenantAccountUpdateForm;
